function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M267.947 299.94l-.063.021h.105l-.042-.011v-.01",
  clipPath: "url(#b)",
  fill: "#003da6"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M195.668 460.104h-.011l.064.044c-.021-.021-.054-.063-.075-.087l.022.043z",
  clipPath: "url(#d)",
  fill: "#003da6"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
}));

var _ref9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e",
  overflow: "visible"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M192.656 338.549l-.038.063c.021-.032.048-.054.069-.085l-.032.031.001-.009z",
  clipPath: "url(#f)",
  fill: "#003da6"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
}));

var _ref12 = /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g",
  overflow: "visible"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M345.146 334.807l-.08-.053a.584.584 0 0 1 .09.105l-.026-.054.016.002",
  clipPath: "url(#h)",
  fill: "#003da6"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "i",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
}));

var _ref15 = /*#__PURE__*/React.createElement("clipPath", {
  id: "j"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i",
  overflow: "visible"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M475.879 372.682l-73.975-5.366 64.266-37.023s-5.7-20.648-21.401-44.325l-68.958 27.258 41.816-61.231s-14.091-16.142-38.512-30.669l-50.297 54.495 11.1-73.336s-19.696-8.406-47.997-10.903l-21.668 70.924-21.816-70.87s-21.408.967-47.991 11.01l11.264 73.293-50.419-54.389s-18.856 10.159-38.442 30.744l41.949 61.146-69.026-27.12s-12.577 17.343-21.296 44.377l64.053 36.728-73.639 5.397s-3.854 21.084 0 49.239l73.963 5.419-64.289 36.96s5.68 20.657 21.36 44.355l68.989-27.227-41.87 61.211s14.081 16.151 38.496 30.688l50.346-54.45-11.168 73.304s19.696 8.438 48.001 10.944l21.721-70.901 21.764 70.882s21.402-.936 47.985-10.967l-11.206-73.305 50.372 54.408s18.884-10.139 38.479-30.689l-41.906-61.188 68.99 27.162s12.603-17.321 21.344-44.355l-64.314-36.938 73.963-5.482c0-.002 3.82-21.06-.031-49.21M365.97 416.831c23.682 16.046 35.902 46.972 60.451 50.414-24.31 11.03-50.84-11.072-78.331-10.86 14.367 24.719 11.971 57.896 32.593 71.646-26.674-.639-40.993-32.028-65.845-43.782 2.205 28.521-14.336 57.363-1.731 78.702-23.756-12.136-23.039-46.65-40.339-68.012-10.372 26.651-37.795 45.462-35.681 70.158-16.152-21.254-.525-52.028-6.858-78.788-20.903 19.512-53.768 24.592-62.582 47.758-5.329-26.163 22.104-47.119 28.013-73.963-27.315 8.502-59.111-1.19-77.108 15.854 6.541-25.865 40.351-32.857 57.315-54.494-28.294-4.165-52.735-26.7-76.349-19.154 17.115-20.468 50.61-12.094 75.281-24.208-23.683-16.046-35.936-46.96-60.483-50.394 24.298-11.03 50.85 11.053 78.331 10.818-14.378-24.719-11.993-57.875-32.625-71.625 26.668.616 41.015 32.02 65.876 43.74-2.226-28.513 14.298-57.364 1.679-78.703 23.768 12.125 23.056 46.651 40.382 67.991 10.361-26.652 37.758-45.474 35.647-70.169 16.158 21.222.547 52.019 6.886 78.768.027.011.06.031.09.042 20.925-19.5 53.788-24.538 62.625-47.693 5.313 26.153-22.136 47.089-28.055 73.932 27.316-8.49 59.112 1.223 77.109-15.812-6.536 25.866-40.361 32.837-57.332 54.441 28.289 4.209 52.72 26.748 76.333 19.225-17.126 20.448-50.612 12.054-75.292 24.168",
  clipPath: "url(#j)",
  fill: "#003da6"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "k",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
}));

var _ref18 = /*#__PURE__*/React.createElement("clipPath", {
  id: "l"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k",
  overflow: "visible"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M348.084 456.363h.012l.021-.063c-.021.021-.042.063-.053.085l.02-.022z",
  clipPath: "url(#l)",
  fill: "#003da6"
});

var _ref20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "m",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "n"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#m",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M296.863 413.834c0 25.888-9.389 38.003-26.472 38.108-17.088-.105-26.487-12.223-26.487-38.108v-71.588h-32.726V411.9c0 44.525 22.104 65.949 59.213 66.438 37.093-.488 59.196-21.912 59.196-66.438v-69.654h-32.726l.002 71.588z",
  clipPath: "url(#n)",
  fill: "#003da6"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "o",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "p"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#o",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M577.652 359.079v45.808c0 13.837 5.318 20.829 14.438 20.829 9.469 0 14.681-6.632 14.681-20.829v-45.808h17.978v44.744c0 24.611-12.418 36.345-33.242 36.345-20.131 0-31.842-11.265-31.842-36.6v-44.489h17.987z",
  clipPath: "url(#p)",
  fill: "#003da6"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "q",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "r"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#q",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M707.838 408.308c-.361-9.579-.713-21.057-.713-32.777h-.244c-2.594 10.182-5.908 21.541-8.979 30.887l-9.702 31.139h-14.092l-8.521-30.882c-2.604-9.356-5.207-20.61-7.228-31.144h-.233a2259.39 2259.39 0 0 1-1.297 33.034l-1.539 30.285h-16.686l5.078-79.771h24.027l7.821 26.632c2.593 9.234 4.974 19.176 6.736 28.527h.469c2.136-9.226 4.855-19.762 7.587-28.656l8.396-26.503h23.678l4.251 79.771h-17.515l-1.294-30.542z",
  clipPath: "url(#r)",
  fill: "#003da6"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "s",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "t"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M798.963 436.597c-3.198 1.553-10.775 3.442-20.36 3.442-27.576 0-41.772-17.278-41.772-40.005 0-27.108 19.403-42.136 43.56-42.136 9.341 0 16.438 1.892 19.64 3.433l-3.783 14.314c-3.562-1.53-8.641-2.955-15.145-2.955-14.208 0-25.335 8.641-25.335 26.396 0 15.852 9.479 25.925 25.44 25.925 5.567 0 11.478-1.062 15.153-2.613l2.602 14.199z",
  clipPath: "url(#t)",
  fill: "#003da6"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "u",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "v"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#u",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M852.809 359.079v45.808c0 13.837 5.313 20.829 14.433 20.829 9.469 0 14.688-6.632 14.688-20.829v-45.808h17.979v44.744c0 24.611-12.423 36.345-33.252 36.345-20.116 0-31.838-11.265-31.838-36.6v-44.489h17.99z",
  clipPath: "url(#v)",
  fill: "#003da6"
}));

var _ref25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "w",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "x"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#w",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M935.061 365.232v15.749h12.901v13.252h-12.901v20.939c0 6.993 1.766 10.202 7.089 10.202 2.497 0 3.678-.129 5.335-.489l.116 13.624c-2.253.809-6.631 1.529-11.604 1.529-5.804 0-10.648-2.021-13.604-4.974-3.325-3.443-4.974-9.013-4.974-17.174v-23.66h-7.693v-13.253h7.693v-10.893l17.642-4.852z",
  clipPath: "url(#x)",
  fill: "#003da6"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "y",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "z"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#y",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M958.365 400.035c0-8.522-.115-14.091-.479-19.054h15.389l.7 10.765h.487c2.955-8.522 9.947-12.071 15.623-12.071 1.656 0 2.485.116 3.782.352v16.929c-1.424-.233-2.827-.467-4.846-.467-6.633 0-11.139 3.421-12.327 9.103-.225 1.188-.341 2.485-.341 4.038v29.224h-17.991l.003-38.819z",
  clipPath: "url(#z)",
  fill: "#003da6"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "A",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "B"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#A",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1016.239 415.662c.585 7.438 7.938 11.01 16.334 11.01 6.144 0 11.114-.851 15.972-2.509l2.371 12.2c-5.908 2.485-13.136 3.678-20.945 3.678-19.648 0-30.893-11.371-30.893-29.479 0-14.681 9.225-30.896 29.224-30.896 18.715 0 25.804 14.559 25.804 28.899 0 3.08-.341 5.802-.585 7.099l-37.282-.002zm21.181-12.321c0-4.367-1.893-11.711-10.054-11.711-7.694 0-10.776 6.981-11.243 11.711h21.297z",
  clipPath: "url(#B)",
  fill: "#003da6"
}));

var _ref28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "C",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "D"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1108.321 437.319c-3.209 1.529-9.233 2.722-16.101 2.722-18.691 0-30.657-11.498-30.657-29.606 0-16.796 11.604-30.644 33.136-30.644 4.738 0 9.945.829 13.729 2.254l-2.825 13.367c-2.147-.944-5.336-1.773-10.073-1.773-9.459 0-15.611 6.748-15.494 16.096 0 10.646 7.099 16.216 15.854 16.216 4.25 0 7.564-.7 10.286-1.893l2.145 13.261z",
  clipPath: "url(#D)",
  fill: "#003da6"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "E",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "F"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1118.248 354.701h17.99v33.251h.244c1.893-2.604 4.262-4.611 7.1-6.024 2.721-1.424 6.036-2.253 9.353-2.253 11.478 0 20.233 7.928 20.233 25.445v33.729h-17.979v-31.838c0-7.571-2.614-12.778-9.353-12.778-4.74 0-7.694 3.07-8.991 6.386-.488 1.062-.604 2.604-.604 3.906v34.323h-17.99l-.003-84.147z",
  clipPath: "url(#F)",
  fill: "#003da6"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "G",
  d: "M61.036 191.599h1158.88v411.668H61.036z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "H"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#G",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1207.014 365.232v15.749h12.901v13.252h-12.901v20.939c0 6.993 1.774 10.202 7.1 10.202 2.485 0 3.677-.129 5.335-.489l.116 13.624c-2.254.809-6.632 1.529-11.604 1.529-5.802 0-10.646-2.021-13.603-4.974-3.315-3.443-4.974-9.013-4.974-17.174v-23.66h-7.694v-13.253h7.694v-10.893l17.63-4.852z",
  clipPath: "url(#H)",
  fill: "#003da6"
}));

function SvgUmcUtrechtLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 888,
    viewBox: "61.036 191.599 1158.88 411.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmcUtrechtLogo);
export default __webpack_public_path__ + "static/media/umc-utrecht-logo.b3700678.svg";
export { ForwardRef as ReactComponent };